import React from "react";

import { useNavigate, useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { listTrips } from "../graphql/queries";
import { Trip } from "../models";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import useAuth from "../components/hooks/useAuth";
import { ListTripsQuery } from "../API";

const ProfilePage: React.FC = () => {
    const { bugId } = useParams<{ bugId: string }>();
    const [trips, setTrips] = useState<Trip[]>([]);
    const navigate = useNavigate();
    const authenticated = useAuth();

    useEffect(() => {
        const fetchTrips = async () => {
            try {
                console.log("Fetching trips for bugId:", bugId);
                const tripDataResponse: any = await API.graphql({
                    query: listTrips,
                    authMode: authenticated ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM",
                    variables: { filter: { owner: { eq: bugId } } },
                }) as { data: ListTripsQuery };
                const tripData = tripDataResponse.data.listTrips?.items as Array<Trip>;
                tripData
                    .sort((a: Trip, b: Trip) => {
                        if (!a?.createdAt) {
                            return 1;
                        }

                        if (!b?.createdAt) {
                            return -1;
                        }
                        const aTime = new Date(a.createdAt).getTime();
                        const bTime = new Date(b.createdAt).getTime();

                        return aTime - bTime;
                    })
                    .reverse();
                setTrips(tripData || []);
            } catch (error) {
                console.error("Error fetching trips:", error);
            }
        };

        if (bugId) {
            fetchTrips();
        }
    }, [bugId, authenticated]);

    return (
        <Grid justifyContent={"center"}>
            <Grid>
                <Typography variant="h2">{bugId}</Typography>
            </Grid>
            <Grid display={"flex"} justifyContent={"center"} marginTop={2}>
                <Grid container spacing={3} justifyContent="center" width={"60%"}>
                    {trips.length === 0 ? (
                        <Typography variant="h6" color="textSecondary">
                            This TravelBug has not been on any trips
                        </Typography>
                    ) : (
                        trips.map((trip) => (
                            <Grid item xs={12} sm={6} md={4} key={trip.id} flexGrow={1}>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Card
                                        style={{ maxWidth: 345, cursor: "pointer" }}
                                        onClick={() => navigate(`/track/${bugId}/${trip.id}`)}
                                    >
                                        <CardHeader title={trip.tripName} />
                                        <CardContent>
                                            <Typography variant="body1">
                                                Destination: {trip.destination}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                Start Date: {trip.startDate}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                End Date: {trip.endDate}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </div>
                            </Grid>
                        ))
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ProfilePage;